import { render, staticRenderFns } from "./reviewer-agency-lists.component.vue?vue&type=template&id=3089b8ec&"
import script from "./reviewer-agency-lists.component.ts?vue&type=script&lang=ts&"
export * from "./reviewer-agency-lists.component.ts?vue&type=script&lang=ts&"
import style0 from "./reviewer-agency-lists.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports